// @flow
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { globalQueryClient } from "queries/queryClient";

import { QUERIES } from "@/enums/queries";

import { getVersion } from "./services/loadVersion";

type VersionResponse = {
  version: string,
};

// $FlowFixMe
export const useLoadVersion = (): UseQueryResult<VersionResponse, Error> => {
  return useQuery({
    queryKey: [QUERIES.VERSION.GET],
    queryFn: () => {
      return getVersion();
    },
    refetchInterval: 1000 * 60 * 60, // 1 hour
    staleTime: 1000 * 60 * 60, // 1 hour
  });
};

export const invalidateLoadVersion = () => {
  globalQueryClient.invalidateQueries({
    queryKey: [QUERIES.VERSION.GET],
    exact: false,
  });
};
